<ion-app>
  <ion-router-outlet animated="false" [swipeGesture]="false"></ion-router-outlet>
  @if (loading) {
    <div class="loader"><ion-spinner name="crescent"></ion-spinner></div>
  }
</ion-app>
